import { List, Text } from '@chakra-ui/react';

import isNil from 'lodash/isNil';

import { IconsLinear } from '@nocowanie/icons/linear';

import { AccommodationTileRatePlanProps } from '@app/components/molecules/accommodation-tile';
import { useAccommodationRatePlanFeatures } from '@app/hooks/useAccommodationRatePlanFeatures';

export const AccommodationTileRatePlan = ({ rate, t }: AccommodationTileRatePlanProps) => {
    const features = useAccommodationRatePlanFeatures(t, rate);

    if (isNil(rate) || !features?.length) {
        return null;
    }

    return (
        <List.Root
            variant="plain"
            fontSize={'xs'}
            flexWrap={'wrap'}
            data-testid={'acc-tile-features'}
            flexDirection={{ base: 'column', md: 'row' }}
            columnGap={{ base: 0.5, md: 2 }}
        >
            {features.map(({ color, fontWeight, key, content, dataTestId, showOnMobile }) =>
                content ? (
                    <List.Item
                        key={key}
                        color={color ?? undefined}
                        data-testid={dataTestId}
                        hideBelow={showOnMobile ? undefined : 'md'}
                        fontWeight={fontWeight}
                    >
                        <List.Indicator asChild color="green.950" mr={1}>
                            <IconsLinear.Tick size={'xs'} />
                        </List.Indicator>
                        <Text
                            as={'span'}
                            dangerouslySetInnerHTML={{
                                __html: content,
                            }}
                        />
                    </List.Item>
                ) : null,
            )}
        </List.Root>
    );
};
